import templateUrl from "emun.salesrep/executive-dashboard.htm";
import dashboardQuickReportFilters from "emun.salesrep/quick-report-filters.htm";
import salesAnalysisURL from "emun.salesrep/sales-analysis-prompt.htm";
import salesrepConfig from "emun.salesrep/salesrep.config";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

class ExecutiveDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this);
    const $ctrl = this;
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.chartLoaded = false;
    $ctrl.productImage = $appConfig.productImage.bind($appConfig);
    $ctrl.currentReport = "";

    $ctrl.repgroups = createAutoQuery({
      //url: 'QuerySalesDailyTotals.json?Sum=ordertotal&groupby=RepGroupName,RepGroupId',
      url: "QueryRepGroups.json?ShowOnDashboard=1",
      autoLoad: true,
    });

    $ctrl.markets = [];
    $ctrl.showCodesQuery = createAutoQuery({
      url: "QueryMarketDates.json",
      autoLoad: true,
      take: 1000,
      onLoaded(args) {
        args.results.forEach((market) => {
          if (
            $ctrl.markets.filter(
              (m) => m.market === market.market && m.year === market.year
            ).length === 0
          ) {
            $ctrl.markets.push(market);
          }
        });
      },
    });

    $ctrl.quickReportsQuery = createAutoQuery({
      url: "QueryQuickReports.json?",
      orderBy: "Type,Name",
      sortOptions: {
        "Type,Name": "Name: A to Z",
        "-Type,Name": "Name: Z to A",
      },
      tagCriteria: {
        Dashboards: "Executive",
      },
      autoLoad: true,
      onLoaded(args) {
        $ctrl.quickReports = args.results;
      },
      pageSize: 1000,
    });

    this.$session = $session;
  }
  load() {
    return this.query.load.apply(this.query, arguments);
  }

  runSalesAnalysisReport() {
    const $main = this;
    return modals.open({
      templateUrl: salesAnalysisURL,
      controllerAs: "$ctrl",
      controller($scope, $uibModalInstance, $session) {
        const $ctrl = this;
        $ctrl.startOn = moment().subtract(1, "days");
        $ctrl.repId = "";
        //$ctrl.endOn = moment().subtract(1, 'days');
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.runReport = function () {
          $uibModalInstance.close();
          console.info("ctrl", $ctrl);
          const url = `${
            $appConfig.serviceUrl
          }RunSalesAnalysis?startDate=${$ctrl.startOn.format(
            "MM/DD/YYYY"
          )}&repId=${$ctrl.request.SalesRep.id}`;
          return (location.href = url);
        };
      },
      size: "lg",
    }).result;
  }

  runReportWithOptions(name, displayName) {
    let $ctrl1 = this;
    $ctrl1.bus = new ServiceBus();
    //console.log("run with options", name);
    return modals.open({
      templateUrl: dashboardQuickReportFilters,
      controllerAs: "$ctrl",
      controller($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        var monthNum = moment().month();
        $ctrl.month = moment().month(monthNum).format("MM");
        $ctrl.startOn = moment();
        $ctrl1.bus
          .send("QuerySalesRepList.json?Active=1&OrderBy=Name")
          .then(function (res) {
            $ctrl.reps = res.data.results;
          });
        $ctrl1.bus
          .send(
            "QueryCustomFieldValues.json?Fields=ValueID,ValueName&take=1000&Id=SuccessIndexRegions&OrderBy=ValueName"
          )
          .then(function (res) {
            $ctrl.regions = res.data.results;
          });
        $ctrl.showReps = true;
        $ctrl.showRegion = true;
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.runReport = function () {
          //$ctrl.startOn = $ctrl.month + "/15/" + moment().year();
          //$ctrl.startOn = $ctrl.startOn.format('MM-DD-YYYY');
          var startOn = $ctrl.startOn.format("MM-DD-YYYY");
          var queryString = "";
          if ($ctrl.repId != undefined) {
            queryString = "&repIdOverride=" + $ctrl.repId.id;
          }
          if ($ctrl.region != undefined) {
            queryString += "&region=" + $ctrl.region.valueID;
          }
          if ($ctrl.dateType != undefined) {
            queryString += "&dateType=" + $ctrl.dateType;
          }
          let url = $appConfig.resolveServiceUrl(
            "RunReport?reportName=" +
              name +
              "&displayName=" +
              displayName +
              "&output=xlsx&startDate=" +
              startOn +
              "&timeZoneOffset=" +
              moment().utcOffset() +
              queryString
          );
          //console.debug("url", $ctrl.startOn, url, $ctrl.repId, $ctrl.dateType);

          return (location.href = url);
        };
      },
      size: "lg",
    }).result;
  }

  runReport(name) {
    //console.info('Run Report');
    const $ctrl = this;
    $ctrl.currentReport = name;
    const url = $appConfig.resolveServiceUrl(name);
    return (location.href = url);
  }
  exportQuickReport(report) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&QuickReportName=" +
        report.name
    );

    return (location.href = url);
  }
}

const ExecutiveDashboard = {
  bindings: {
    repId: "@",
  },
  controller: ExecutiveDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default ExecutiveDashboard;
